import { PEOPLE_DIRECTORY_PATH, TEAM_DIRECTORY_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const teamsDirectoryRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: TEAM_DIRECTORY_PAGE,
	path: `${PEOPLE_DIRECTORY_PATH}/:search(search)?`,
	subproduct: 'townsquare-people-team-directory',
	query: ['screen=(SEARCH_TEAMS|YOUR_TEAMS)'],
});
